// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios"
import "./reset/reset.css"
Vue.config.productionTip = false
Vue.prototype.axios = axios;
import qs from "qs"
Vue.prototype.qs = qs;
axios.defaults.baseURL ="https://api.cjkt.com/"
//懒加载插件
import VueLazyLoad from 'vue-lazyload'
//引入iview UI框架
//import iView from 'iview';
//import 'iview/dist/styles/iview.css';
Vue.use(VueLazyLoad,{
  loading:'./static/bg.png'
})
//Vue.use(iView);



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js